export default __webpack_public_path__ + "static/media/burkina-faso.42b537ce.png";